import { Button, Checkbox, FormControlLabel } from '@material-ui/core';
import { observer } from 'mobx-react';
import * as React from 'react';
import { NavLink } from 'react-router-dom';

import { LoginPageContainer } from '../login-page';
import { MatField } from 'src/core/components/mat-field';
import { PageError } from 'src/core/components/page-error/page-error';

import styles from './login-page.less';
import { Consts } from 'src/login/shared/consts';

const emailErrorMap = {
    required: null,
    email: null,
};

const passwordErrorMap = {
    error: null,
};

interface Props {
    container: LoginPageContainer;
}

export const LoginPage: React.SFC<Props> = observer(
    ({ container: { data, handleSubmit, loginError, clearError } }) => (
        <div className="page page-inverted login-image-background">
            <div className="page-topping">
                <PageError message={loginError} onClose={clearError} />
            </div>

            <div className="row">
                <div className="col">
                    <div className="page-title">
                        <h1>
                            Welcome <br />
                            <i>to customer portal</i>
                        </h1>
                    </div>
                </div>
                <div className="col">
                    <div className="card">
                        <form className="flex-form" onSubmit={handleSubmit}>
                            <h1>Let's log in</h1>
                            <div className="card-content">
                                <div className={styles.formField}>
                                    <MatField
                                        className="full-width"
                                        type="email"
                                        name="email"
                                        label="Email"
                                        fieldState={data.email}
                                        errorMap={emailErrorMap}
                                        autoFocus
                                    />
                                </div>
                                <div className={styles.formField}>
                                    <MatField
                                        className="full-width"
                                        type="password"
                                        name="password"
                                        label="Password"
                                        fieldState={data.password}
                                        errorMap={passwordErrorMap}
                                        autoComplete="new-password"
                                        endAdornment={
                                            <NavLink to="/login/forgot">Forgot Password</NavLink>
                                        }
                                    />
                                </div>
                                <div className={styles.checkbox}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="stayLoggedIn"
                                                checked={data.stayLoggedIn.value}
                                                onChange={(e) =>
                                                    data.stayLoggedIn.onChange(e.target.checked)
                                                }
                                            />
                                        }
                                        label="Stay logged in"
                                    />
                                </div>
                            </div>
                            <div className="space-filler" />
                            <div>
                                <span>
                                    By clicking Login below you agree to the{' '}
                                    <a href={Consts.termsUrl} target="blank">
                                        Terms of Service
                                    </a>
                                </span>
                            </div>
                            <Button
                                className="next-step-button"
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={!!data.form.error}
                            >
                                Login
                            </Button>
                            <div id="recaptcha-div" />
                        </form>
                    </div>
                    <div className="centered-content">
                        <p className="last-help">
                            <span className="gray-text">Not a member?</span>{' '}
                            <NavLink to="/login/sign-up">Request an invitation</NavLink>
                        </p>
                    </div>
                </div>
                <div className="col" />
            </div>
        </div>
    )
);
